import React from 'react';
import PlanCard from "./components/PlanCard";
import {PLANS} from "../../constants/plans";
import {QUARTERLY} from "../../constants/plans/pro-student";

import styles from './PricingGrid.module.css';

const FREE_FEATS = [
  {
    label: 'Remove Tiiny Host Banner',
    tooltip: 'No Tiiny Host branding on your content',
  },
  {
    label: 'Custom domains',
    tooltip: 'Use your website name to publish your content, custom SSL included',
  },
  {
    label: 'Built-in Analytics',
    tooltip: 'Automatically track the number of visitors and where they\'re coming from',
  },
  {
    label: 'Password protection',
    tooltip: 'Restrict who can view your content by adding a password',
  },
  {
    label: 'Fast Global hosting (CDN)',
    tooltip: 'Our Content Delivery Network ensures your content loads fast worldwide',
  },
  {
    label: 'PDF & code editor',
    tooltip: 'Easily edit text in PDFs, HTML, CSS & JavaScript files online using our built-in editor',
  },
  {
    label: 'Add team members',
    tooltip: 'Share account with up to two more users (upgradeable)',
  }
]

const SOLO_FEATS = [
  {
    label: 'Remove Tiiny Host Banner',
    tooltip: 'No Tiiny Host branding on your content',
    enabled: true
  },
  {
    label: 'Custom domains',
    tooltip: 'Use your website name to publish your content, custom SSL included',
    enabled: true
  },
  {
    label: 'Built-in Analytics',
    tooltip: 'Automatically track the number of visitors and where they\'re coming from',
    enabled: true
  },
  {
    label: 'Password protection',
    tooltip: 'Restrict who can view your content by adding a password',
    enabled: true
  },
  {
    label: 'Fast Global hosting (CDN)',
    tooltip: 'Our Content Delivery Network ensures your content loads fast worldwide',
    enabled: true
  },
  {
    label: 'PDF & code editor',
    tooltip: 'Easily edit text in PDFs, HTML, CSS & JavaScript files online using our built-in editor',
    enabled: true
  },
  {
    label: 'Add team members',
    tooltip: 'Share account with up to two more users (upgradeable)',
    enabled: false
  }
]

const PRO_FEATS = [
  ...SOLO_FEATS.map((f) => ({ ...f,
      enabled: true
  })),
]

const STUDENT_FEATS = [
  {
    label: 'Remove Tiiny Host Banner',
    tooltip: 'No Tiiny Host branding on your content',
    enabled: true,
  },
  {
    label: 'Custom domains',
    tooltip: 'Use your website name to publish your content, custom SSL included',
    enabled: true,
  },
  {
    label: 'Built-in Analytics',
    tooltip: 'Automatically track the number of visitors and where they\'re coming from',
  },
  {
    label: 'Password protection',
    tooltip: 'Restrict who can view your content by adding a password',
  },
  {
    label: 'Fast Global hosting (CDN)',
    tooltip: 'Our Content Delivery Network ensures your content loads fast worldwide',
  },
  {
    label: 'Edit static files online',
    tooltip: 'Quickly edit HTML, CSS & JavaScript files online using our built-in code editor',
  },
]

export const StudentPricingGrid = ({ onClick }) => (
  <PlanCard
    plan={PLANS.PRO_STUDENT}
    subtitle="For creators & builders in training"
    features={STUDENT_FEATS}
    period={QUARTERLY}
    position="single"
    ctaTheme="purple"
    onSubPlanClick={onClick}
  />
)

const PricingGrid = ({className, period, onSubPlanClick, onFreeClick, hideFreeCard}) =>
  (<div className={`${className} flex ${styles.container}`}>
    <PlanCard
      plan={PLANS.PRO_U}
      title="Pro"
      subtitle="For freelancers, agencies & organizations"
      features={PRO_FEATS}
      period={period}
      position="start"
      ctaTheme="warning"
      onSubPlanClick={onSubPlanClick}
    />
    <PlanCard
      plan={PLANS.PRO}
      title="Solo"
      subtitle="Great for individuals and small sites"
      features={SOLO_FEATS}
      period={period}
      position={`${hideFreeCard ? 'end' : 'center'}`}
      ctaTheme="purple"
      onSubPlanClick={onSubPlanClick}
      popular
    />
    {!hideFreeCard && <PlanCard
      plan={PLANS.FREE}
      subtitle="Try us out for a quick project or two"
      features={FREE_FEATS}
      period={period}
      position="end"
      ctaTheme="outline-primary"
      onSubPlanClick={onFreeClick}
    />}
  </div>)

export default PricingGrid;